export default {
  anyMistakes:
    'Se ritieni che qualunque informazione presente su questa pagina non sia corretta, ti preghiamo di',
  contactUs: 'contattarci',
  social: 'Siamo sociali | Seguici',
}
